import { UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';
import { GlobalSearchProductCodeParams } from '../../../modules/global-search/globalSearch.types';

export const getGlobalSearchProductCodeKey = (
  params: GlobalSearchProductCodeParams,
  brandId?: string,
): UseDataQuery['queryKey'] => ['global-search-product-code', brandId, { q: params.q }];
